import { render, staticRenderFns } from "./OrderStatusChip.vue?vue&type=template&id=27fbc550&scoped=true&lang=pug&"
import script from "./OrderStatusChip.vue?vue&type=script&lang=js&"
export * from "./OrderStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fbc550",
  null
  
)

export default component.exports